// @flow
// $FlowFixMe
import React from 'react';
import {TripBoardsModalApolloProvider} from '@homeaway/react-trip-board-button';
import Experiment from '@homeaway/react-experiment';
import LoginExperience from '../LoginExperience/LoginExperience';
import {HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} from '../../abacus/experiments';
type TripBoardsProviderContainerProps = {
    siteName: string,
    isLoggedIn: boolean,
    tripBoardProviderSearchParams: Object
};
export default function TripBoardsProviderContainer({
    siteName,
    tripBoardProviderSearchParams,
    isLoggedIn
}: TripBoardsProviderContainerProps) {
    return (
        <Experiment name={HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} deferLogging>
            {({On, Off}) => (
                <React.Fragment>
                    <On>
                        <TripBoardsModalApolloProvider
                            siteName={siteName}
                            {...tripBoardProviderSearchParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                            showCoachmark
                            {...(!isLoggedIn && {
                                renderInitialModal: (
                                    onComplete,
                                    onClose,
                                    isOpen
                                ) =>
                                    isOpen && (
                                        <LoginExperience
                                            modalMode
                                            actionLocation="heartButtonLogin"
                                            onClose={onClose}
                                            onSuccess={onComplete}
                                            configContext="savetripboard"
                                        />
                                    )
                            })}
                        />
                    </On>
                    <Off>
                        <TripBoardsModalApolloProvider
                            siteName={siteName}
                            {...tripBoardProviderSearchParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                            showCoachmark
                        />
                    </Off>
                </React.Fragment>
            )}
        </Experiment>
    );
}
